import { ContentAccordionComponent, Section } from '../contentAccordion/ContentAccordion'

interface InfoProps {
  sections: Section[]
}

export const InfoComponent = ({ sections }: InfoProps) => (
  <div className="w-full">
    {sections.map((section, index) => (
      <ContentAccordionComponent opened={index === 0} section={section} key={section.title} />
    ))}
  </div>
)
